import { IndicatorData } from '../TechnicalAnalysisTradingView';

export interface OhlcRow {
  time: number;
  open: number;
  high: number;
  low: number;
  close: number;
  volume?: number;
}

export function calculateSMA(data: OhlcRow[], period: number): IndicatorData[] {
  const result: IndicatorData[] = [];
  if (!data || data.length < period || period <= 0) return result;

  let sum = 0;
  for (let i = 0; i < period; i++) {
    sum += data[i]?.close ?? 0;
  }

  result.push({
    time: data[period - 1]?.time ?? 0,
    value: sum / period
  });

  for (let i = period; i < data.length; i++) {
    sum += (data[i]?.close ?? 0) - (data[i - period]?.close ?? 0);
    result.push({
      time: data[i]?.time ?? 0,
      value: sum / period
    });
  }

  return result;
}
